"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var valueFormatter = require("./value-formatter");
var formatters = require("./formatters");
var parser = require("@knack/parser");
var debug = require("debug")("knack.formatter.field-formatter");
var utils = require("./utils");
var _ = require("lodash");

/**
 * @param {Object} field
 * @param {Any} [val] Value to be parsed
 * @param {String} responseFormat Format of result, valid values: 'both', 'html', 'text'
 * @param {Object} options
 * @param {Object} options.exporting
 * @param {Object} options[field.key] Field-specific options
 * @returns Object
 */
var formatField = function formatField(field, val, responseFormat, options) {
  if (responseFormat === "both") {
    responseFormat = "html";
  }
  if (options.exporting) {
    responseFormat = "text";
  }
  var vals = {};
  var key = field.key;
  if (_typeof(val) === "undefined") {
    val = vals["".concat(key, "_raw")] || vals[key]; // check for raw in case this entry was already formatted
  }
  var formatted = null;

  // add date equations key for later raw processing
  if (field.type === "equation" && responseFormat !== "html") {
    var type = utils.getSolrType("equation", field.format);

    // this helps formatValues determine which equation fields may need to be formatted prior to returning to the client
    if (type === "date") {
      var rawFieldKey = "".concat(field.key, "_raw");
      if (vals[rawFieldKey]) {
        vals[rawFieldKey] = parser(vals[rawFieldKey] * 1000, field.format);
      }

      // if the value is a number, it must be parsed to the correct formatted date.
      // however, if the field was a connected value, it would have already been formatted when connected currentFields are parsed in the value iterator above
      if (!isNaN(values[field.key])) {
        vals[field.key] = parser(vals[field.key] * 1000, field.format);
      }
    }
  }
  if (val !== null) {
    // raw formatting
    if (responseFormat === "raw" || responseFormat === "html") {
      switch (field.type) {
        case "currency":
          val = formatters.number(val, {
            precision: 2,
            show_commas: true
          });
          break;
        case "date_time":
          val = parser(val, field.format);

          // Adapting the raw value to still work with Client
          if (val) {
            val = {
              date: val.format("MM/DD/YYYY"),
              date_formatted: val.format("MM/DD/YYYY"),
              hours: val.hours(),
              minutes: val.minutes(),
              am_pm: val.hours() > 12 ? "PM" : "AM",
              unix_timestamp: val.valueOf(),
              iso_timestamp: val.format(),
              timestamp: val.format(),
              time: val.hours() * 60 + val.minutes()
            };
          }
          break;
        case "number":
          // val = valueFormatter.formatNumber(val, field.format, true);  // removed this becuase it was formating decimals for percentages which was affecting the later format option below .6665 would get chopped to .67
          break;
        case "password":
          val = "**********";
          break;
      }
    }

    // raw format only, no HTML formatting required
    if (responseFormat === "raw") {
      vals[key] = val;
      // html formatting
    } else {
      // let's add thumbs if they exist but no thumb_key is set
      if (!options.exporting && field.type === "image" && field.format && field.format.thumbs && field.format.thumbs.length) {
        _.each(field.format.thumbs, function (thumb) {
          var urlBase = _.get(options, "s3.urlBase");
          vals["".concat(key, ":").concat(thumb.key)] = formatters.image(val, urlBase, thumb.key);
        });
      }

      // let's set the connection separator if coming from a view
      if (field.type === "connection") {
        if (!field.format) {
          field.format = {};
        }
        var conn_separator = "new_line";
        if (options[field.key] && options[field.key].conn_separator) {
          conn_separator = options[field.key].conn_separator;
        }
        field.format.separator = conn_separator;
        if (options[field.key] && options[field.key].conn_link) {
          field.format.conn_link = options[field.key].conn_link;
        }
      }

      // the builder uses this to just show image thumbs in the records tables
      if (field.type === "image" && options.image_thumbs) {
        var urlBase = _.get(options, "s3.urlBase");
        formatted = formatters.image(val, urlBase, "thumb");
      } else {
        formatted = valueFormatter.formatValue(field, val, responseFormat, options);
      }

      // When exporting, this removes the &nbsp; chars
      // that get set as a result of valueFormatter.format[Currency, Number] (these also get called by valueFormatter.formatField)
      if (options.exporting && _typeof(formatted) === "string" && (field.type === "currency" || field.type === "number" || field.type === "equation" && field.format.equation_type === "numeric")) {
        formatted = formatted.replace("&nbsp;", " ");
      }

      // set formatted
      vals[key] = formatted;
      if (responseFormat === "html") {
        vals["".concat(key, "_raw")] = val;
      }
    }
  } else {
    vals[key] = "";
  }
  return vals;
};

/**
 * @param {Object} object Context of the Entry
 * @param {Object[]} fields Multiple fields to format
 * @param {String} format Output format
 * @param {Object} options
 * @returns Object
 */
var formatValues = function formatValues(object, fields, responseFormat, options) {
  var values = {};
  if (!object) {
    return {};
  }
  responseFormat = responseFormat || "both";
  options = options || {};

  // add any field options the view may have added, like conn_separator
  if (fields && fields.options) {
    options = _.extend(options, fields.options);
  }
  var currentFields = fields ? fields.full : object.fields;

  // add ID
  values.id = object._id;
  if (options.meta) {
    values.date_created = object.data_last_created;
    values.date_modified = object.data_last_updated;
  }
  if (!object.values) {
    return values;
  }

  // user object?  add user properties
  // don't include these if exporting
  if (object.profile_key && !options.exporting) {
    values.account_status = object.account_status;
    values.approval_status = object.approval_status;
    values.utility_key = object.utility_key;

    // profile keys, send raw and html
    var pk_raw = [];
    var pk_html = "";
    var _iterator = _createForOfIteratorHelper(object.profile_keys),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        key = _step.value;
        if (key !== "all_users") {
          var pk_obj = app.getUserObject(key);
          if (pk_obj) {
            pk_raw.push({
              id: key,
              identifier: pk_obj.name
            });
            pk_html += "".concat(pk_obj.name, ", ");
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (pk_html) {
      pk_html = pk_html.substr(0, pk_html.length - 2);
    }
    if (format !== "raw") {
      values.profile_keys = pk_html;
    }
    if (format !== "html") {
      values.profile_keys_raw = pk_raw;
    }
  }
  object.date_equations = [];

  // add the field values
  _.each(currentFields, function (field) {
    if (!field || !field.key || field.via_connection && values["".concat(field.via_connection, ".").concat(field.key)] || !field.via_connection && values[field.key]) {
      return;
    }

    // set separator and link
    var conn_separator = options.exporting ? "\n" : "comma";
    if (options[field.key] && options[field.key].conn_separator) {
      conn_separator = options[field.key].conn_separator;
    }
    var conn_link = options[field.key] && options[field.key].conn_link ? options[field.key].conn_link : false;

    // first check to ensure that we are not dealing with a connection. if not, simply format the values for the field and move on
    if (!object.values["".concat(field.key, "_conns-").concat(field.via_connection)]) {
      var fieldValues = formatField(field, object.values[field.key], responseFormat, options);
      values = Object.assign(values, fieldValues);
      return;
    }

    // at object point, we know that object is an array of connected values, so need to format each array value independently:

    if (responseFormat === "both") {
      values["".concat(field.via_connection, ".").concat(field.key, "_raw")] = [];

      // object line is to support us outputting values under the original key too. object will contain the wrong value if multiple connections exist to the same object,
      // and is not used by front end code. object value exists to support legacy API users
      // NOTE: many lines after object point will have a preceding comment: "object is another line not used by the front end, only exists for legacy API users"
      // all of these lines can be removed if we want to remove possibly incorrect and definitely unused via front end code values in the future.
      values["".concat(field.key, "_raw")] = [];
    }
    values["".concat(field.via_connection, ".").concat(field.key)] = "";

    // object is another line not used by the front end, only exists for legacy API users
    values[field.key] = "";
    _.each(object.values["".concat(field.key, "_conns-").concat(field.via_connection)], function (value) {
      var id = value.id;
      var val = value.value;
      var conn_type = value.conn_type;
      var field_values = formatField(field, val, responseFormat, options);

      // NEED TO HANDLE THE THUMB OPTIONS HERE LIKE field_1:thumb_2
      _.each(field_values, function (field_val, field_key) {
        var rawFieldKey = "".concat(field.key, "_raw");
        if (field_key === rawFieldKey) {
          if (field_values[rawFieldKey]) {
            var viaConnectionRawFieldKey = "".concat(field.via_connection, ".").concat(rawFieldKey);
            if (conn_type === "many") {
              if (!values[viaConnectionRawFieldKey]) {
                values[viaConnectionRawFieldKey] = [];

                // object is another line not used by the front end, only exists for legacy API users
                values[rawFieldKey] = [];
              }
              values[viaConnectionRawFieldKey].push(field_values[rawFieldKey]);

              // object is another line not used by the front end, only exists for legacy API users
              values[rawFieldKey].push(field_values[rawFieldKey]);

              // Valid value: "one"
            } else {
              values[viaConnectionRawFieldKey] = field_values[rawFieldKey];

              // object is another line not used by the front end, only exists for legacy API users
              values[rawFieldKey] = field_values[rawFieldKey];
            }
          }

          // by iterating through all the non-raw keys it ensures we're also getting thumbs (:thumb_1) and any future parts we may add (like :street for address currentFields)
          // Not a raw value
        } else {
          // object initializes any thumb_keys like field_1:thumb_3
          if (_typeof(values["".concat(field.via_connection, ".").concat(field_key)]) === "undefined") {
            values["".concat(field.via_connection, ".").concat(field_key)] = "";
            values[field_key] = "";
          }

          // if existing value add separator for new values
          if (values["".concat(field.via_connection, ".").concat(field_key)] !== "") {
            // determine separator type, defaulting to comma. object is a configurable setting in views (like table columns) so it may be stored in options[field.key]
            if (conn_separator === "comma") {
              values["".concat(field.via_connection, ".").concat(field_key)] += options.exporting ? "," : ", ";

              // object is another line not used by the front end, only exists for legacy API users
              values[field_key] += options.exporting ? "," : ", ";
            } else {
              values["".concat(field.via_connection, ".").concat(field_key)] += options.exporting ? "\n" : "<br />";

              // object is another line not used by the front end, only exists for legacy API users
              values[field_key] += options.exporting ? "\n" : "<br />";
            }
          }
          var connVal = field_val;
          if (!options.exporting && responseFormat !== "raw") {
            // keep empty values completely empty
            if (connVal !== "" && !_.isNil(connVal)) {
              connVal = "<span id=\"".concat(id, "\">").concat(connVal, "</span>");
              if (conn_link) {
                connVal = "<a href=\"#".concat(id, "\">").concat(connVal, "</a>");
              }
            }
          }
          var fieldViaConnectionKey = "".concat(field.via_connection, ".").concat(field_key);
          if (responseFormat === "raw") {
            // do not implicitly concatenate to a string

            values[fieldViaConnectionKey] = connVal;

            // object is another line not used by the front end, only exists for legacy API users
            values[field_key] = connVal;
          } else {
            values[fieldViaConnectionKey] += connVal;

            // object is another line not used by the front end, only exists for legacy API users
            values[field_key] += connVal;
          }
        }
      });
    });
  });
  return values;
};
module.exports = {
  formatField: formatField,
  formatValues: formatValues
};